import React from 'react'
import styled from 'styled-components'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

const AiDraftBanner = ({ filename }) => (
  <Banner role='note' data-tour-id='formBuilder.aiDraftBanner' data-testid='ai-draft-banner'>
    <AutoAwesomeOutlinedIcon aria-hidden='true' />
    <span>
      This form was drafted by AI from {filename ? <strong>{filename}</strong> : 'your document'}. Check every question, change anything that is not right, then publish it.
    </span>
  </Banner>
)

export default AiDraftBanner

const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 12px;
  background: #eaf8fa;
  border: 1px solid #bfe9ee;
  color: #0C1229;
  font-size: 15px;
  line-height: 1.5;
  overflow-wrap: anywhere;

  svg { font-size: 20px; color: #1f8b98; flex: 0 0 auto; margin-top: 1px; }
`
